import { AdultPaywallProps } from './AdultPaywall.interface';
import { AdultPaywallNew } from '$core/Subscription/AdultPaywall/AdultPaywallNew';

export const AdultPaywall = (props: AdultPaywallProps) => {
  return <AdultPaywallNew {...props} />;
};
